import { Box, Typography, useTheme } from '@mui/material';
import { CopyContentDto } from '@act/shared/data-transfer-objects';
import CopyEntry from './CopyEntry';
import { reemaColors } from '@act/storybook';

interface CopySectionProps {
  content: CopyContentDto;
}

const CopySection = ({ content }: CopySectionProps) => {
  const theme = useTheme();

  return (
    <Box
      component="div"
      sx={{
        ...(content.isHighlighted && {
          padding: '24px 24px 4px',
          backgroundColor: theme.palette.navyShades[50],
          borderRadius: '16px',
        }),
        '& .copy-entry': {
          marginBottom: '24px',
        },
        '& .copy-entry .entry-title': {
          marginBottom: '12px',
        },
      }}
    >
      {content.title && (
        <Box component="div" sx={{ padding: '12px 0 16px' }}>
          <Typography
            component="span"
            variant="subheadLarge"
            color={reemaColors.black}
          >
            {content.title}
          </Typography>
        </Box>
      )}
      {[...content.entries]
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((entry, index) => {
          return (
            <CopyEntry
              key={`copy-entry-${entry.copyType}-${index}`}
              entry={entry}
            />
          );
        })}
    </Box>
  );
};

export default CopySection;
